import React from'react';import PropTypes from'prop-types';import styles from"./style";/**
 * The manufacturer component.
 * @param {Object} props The component props.
 * @param {string} props.text The manufacturer name.
 * @param {string} [props.className] CSS classes.
 * @return {JSX}
 */var Manufacturer=function Manufacturer(_ref){var className=_ref.className,text=_ref.text;return React.createElement("div",{className:"".concat(styles," ").concat(className)},React.createElement("span",{dangerouslySetInnerHTML:{__html:text}}));};Manufacturer.defaultProps={className:''};export default Manufacturer;